module.exports = __webpack_public_path__ + "img/comparison-yes.svg";